import {
  TemplateComponent,
  TemplateParameters,
  TemplateParams,
} from '../../schema/message/template-schema';
import {
  InteractiveButtonAction,
  InteractiveCtaUrlAction,
  InteractiveFlowAction,
  InteractiveListAction,
  MenuItem,
  MsgTemplate,
  TemplateButtons,
  TemplateComponents,
  WhatsAppInteractive,
} from '../../schema/message/inferface';
import {
  buttonsActionSchema,
  ctaUrlSchema,
  flowActionSchema,
  listActionSchema,
} from '../../schema/message/interactive-template-schema';
import { TemplateButtonTypeEnum } from '../../schema/message/enum';

const getInteractiveTemplate = (template: WhatsAppInteractive): MsgTemplate => {
  const { body, header, footer } = template || {};
  const { text = '' } = body || {};
  const { text: footerText = '' } = footer || {};
  const textComponent = { type: 'BODY', text: `${text}\n\n${footerText}` };
  const headerComponent = {
    type: 'HEADER',
    format: 'IMAGE',
  } as TemplateComponent;
  const components: TemplateComponents = [];
  const params: TemplateParams = [];
  if (header) components.push(headerComponent);
  params.push({
    type: 'header',
    parameters: [header as TemplateParameters],
  });
  if (textComponent) components.push(textComponent);
  return {
    interative: {
      params: params,
      components: components,
    },
  };
};

const getButtonsFromInteractiveTemplate = (
  template: WhatsAppInteractive
): TemplateButtons[] => {
  const { action, type } = template || {};
  if (type === 'list' && listActionSchema.safeParse(action).success) {
    const listAction = action as InteractiveListAction;
    const button: TemplateButtons = {
      text: listAction.button || '',
      type: TemplateButtonTypeEnum.INTERACTIVE,
      condition: true,
      permissions: [],
      onPress: () => {},
      disabled: true,
      menuItems: listAction.sections[0].rows.map(
        ({ title, description }) =>
          ({
            title,
            description,
          }) as MenuItem
      ),
    };
    return [button];
  } else if (
    type === 'button' &&
    buttonsActionSchema.safeParse(action).success
  ) {
    const buttonAction = action as InteractiveButtonAction;
    const buttons: TemplateButtons[] = buttonAction.buttons.map(
      ({ reply }) => ({
        text: reply.title || '',
        type: TemplateButtonTypeEnum.QUICK_REPLY,
        condition: true,
        permissions: [],
        onPress: () => {},
        disabled: true,
      })
    );
    return buttons;
  } else if (type === 'cta_url' && ctaUrlSchema.safeParse(action).success) {
    const ctaAction = action as InteractiveCtaUrlAction;
    const button: TemplateButtons = {
      text: ctaAction.parameters.display_text,
      type: TemplateButtonTypeEnum.URL,
      condition: true,
      permissions: [],
      onPress: () => {},
      navigateTo: ctaAction.parameters.url,
    };
    return [button];
  } else if (type === 'flow' && flowActionSchema.safeParse(action).success) {
    const flowAction = action as InteractiveFlowAction;
    const button: TemplateButtons = {
      text: flowAction.parameters.flow_cta,
      type: TemplateButtonTypeEnum.INTERACTIVE,
      condition: true,
      permissions: [],
      onPress: () => {},
      disabled: true,
    };
    return [button];
  }
  return [];
};

export const getInteractiveTemplateWithButtons = (
  template: WhatsAppInteractive
): { template: MsgTemplate; buttons: TemplateButtons[] } => {
  return {
    template: getInteractiveTemplate(template),
    buttons: getButtonsFromInteractiveTemplate(template),
  };
};
